var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.validade)?_c('div',{staticClass:"countdown"},[_c('div',{staticClass:"time"},[_c('div',{staticClass:"time-item"},[_c('p',[_vm._v("Este cupom expira em "+_vm._s(_vm.hours)+"h:"+_vm._s(_vm.minutes)+"m:"+_vm._s(_vm.seconds)+"s")])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }